import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ui-empty"
}
const _hoisted_2 = {
  key: 1,
  role: "alert",
  class: "ui-alert ui-alert--error"
}
const _hoisted_3 = {
  key: 2,
  class: "ui-empty"
}
const _hoisted_4 = {
  key: 3,
  class: "catalog-grid"
}
const _hoisted_5 = { class: "catalog-icon" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "catalog-open" }

import { Spinner } from '@/components/ui/spinner';
import { Package, ArrowUpRight } from '@lucide/vue';

import { onMounted, ref } from 'vue';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductList',
  setup(__props) {

const loading = ref(false);
const errorMessage = ref('');
const products = ref<Product[]>([]);

async function loadProducts() {
  loading.value = true;
  errorMessage.value = '';
  try {
    products.value = (await axios.get('/api/products/catalog/')).data as Product[];
  } catch (error) {
    console.error('Failed to load products catalog:', error);
    errorMessage.value = 'Не удалось загрузить каталог продуктов';
  } finally {
    loading.value = false;
  }
}

onMounted(async () => {
  await loadProducts();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Spinner)),
          _cache[0] || (_cache[0] = _createElementVNode("span", null, "Загрузка продуктов…", -1))
        ]))
      : (errorMessage.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(errorMessage.value), 1))
        : (products.value.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Продукты не найдены"))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: product.id,
                  to: { name: 'product-detail', params: { id: product.id } },
                  class: "catalog-product ui-panel"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_5, [
                      (product.icon)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: product.icon,
                            alt: product.name
                          }, null, 8, _hoisted_6))
                        : (_openBlock(), _createBlock(_unref(Package), {
                            key: 1,
                            size: 26
                          }))
                    ]),
                    _createElementVNode("h2", null, _toDisplayString(product.name), 1),
                    _createElementVNode("span", _hoisted_7, [
                      _cache[1] || (_cache[1] = _createTextVNode(" Открыть карточку ", -1)),
                      _createVNode(_unref(ArrowUpRight), { size: 16 })
                    ])
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ]))
  ]))
}
}

})